import { User } from './../../model/UserModel';
import { Organization } from '../../model/OrganizationModel';
import { Contributor } from '../../model/ContributorModel';

export interface UserState {
  loading: boolean;
  error: boolean;
  user: User;
  contributor: Contributor;
  organization: Organization;
  token: string;
  authenticated: boolean;
  resetPasswordOk: boolean;
  resetPasswordError: boolean;
  expired: boolean;
}

export const initialState: UserState = {
  loading: false,
  error: false,
  user: null,
  contributor: null,
  organization: null,
  token: null,
  authenticated: false,
  resetPasswordOk: false,
  resetPasswordError: false,
  expired: true
};


// WEBPACK FOOTER //
// ./src/store/state/UserState.ts